import React, { useContext, useState, useEffect } from "react";
import ToggleButton from 'react-toggle-button';
import { Grid, Row, Col, Modal} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search, ColumnToggle, CSVExport } from 'react-bootstrap-table2-toolkit';
import useValidator from '../hooks/useValidator';
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { FetchAPI } from "api/fetch";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import BeatLoader from "react-spinners/BeatLoader";
import "react-toggle/style.css"
import { useTranslation } from 'react-i18next';
import SimpleReactValidator from 'simple-react-validator';
import { hidePaginationDropdown } from '../constants/staticVariables'
import { MDBRow, MDBCol } from 'mdbreact';
import FilterBox from '../components/FilterBox/FilterBox';
import ButtonField from '../components/UI/Button/ButtonField';
import ModalBox from '../components/ModalBox/ModalBox';
import swal from 'sweetalert';
import Cookies from 'universal-cookie';
import { isEmpty } from "components/Login/validator";
import Wizard from './PageType-3.jsx';
import { Timeline, TimelineItem }  from 'vertical-timeline-component-for-react';
import 'assets/css/custom.css';
import { PostAPI } from "api/post";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import { WizardDataContext } from "context/WizardDataContext";
import { getWizardDataService } from "services/wizardDataService";
import { getStatusAlert, getReportTotalQuanties } from "utilities/CommonUtils";
let logoValMain = require('../../src/assets/img/access-denied.png');
const cookies = new Cookies();


const Role = props => {
  let [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
  let [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
  let pageLayoutDataContext = (featureBlueprint.data == undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData.pageTypes[0].bodyLayout;
  const [validate, showValidationMessage] = useValidator();
  let [pageLayoutData, setPageLayoutData] = useState('undefined');
  const { SearchBar, ClearSearchButton } = Search;
  const { ToggleList } = ColumnToggle;
  const { ExportCSVButton } = CSVExport;
  const { t, i18n } = useTranslation();
  const divRef = React.useRef()
  const [defaultTextMessage, setDefaultTextMessage] = useState()
  const [showFilter, setshowFilter] = useState(false);
  const [showCSearch, setshowCSearch] = useState(false);
  const [showModal, setshowModal] = useState(false);
  let [loading, setLoading] = useState(false);
  let[commonTitle, setCommonTitle] = useState("");
  let[unBindUrl,setUnBindUrl] = useState()
  let [iotQty, setIotQty] = useState();
  let [qty, setQty] = useState();
  let [revertqty, setRevertQty] = useState();
  let [loadTableData, setloadTableData] = useState(true);
  let [errorMsg, setErrorMsg] = useState();
  let [error, setError] = useState(false);
  let [page, setpage] = useState(1);
  let [sizePerPage, setsizePerPage] = useState(10);
  let [totalrecords, settotalrecords] = useState();
  let [isFilterLoader, setIsFilterLoader] = useState(false);
  let [modalType, setmodalType] = useState(`${t('add')}`);
  let [uniqueId, setuniqueId] = useState();
  let [extraId, setextraId] = useState();
  const titlesList = ['Supplier Inventory','Linewise Production','Batch Wise Production','Supplier Wise Dispatch']
  let [searchInputValue, setsearchInputValue] = useState();
  let [productsData, setproductsData] = useState([]);
  let [modalgetURL, setmodalgetURL] = useState('');
  let [localPageLoadIndicator, setLocalPageLoadIndicator] = useState(globalLoadIndicator);
  let [dropDownApi, setDropDownApi] = useState();
  let [saveUrl, setSaveUrl] = useState();
  let [filteredCondition, setFilteredCondition] = useState(false)
  let [addButtonPermission, setAddButtonPermission] = useState(false);
  let [renderComponent, setRenderComponent] = useState(false);
  let [showParentContent, setShowParentContent] = useState(true);
  let [selectChildValue, setSelectChildValue] = useState([]);
  let [loadTableDataChild, setloadTableDataChild] = useState(true);
  let [columnsChild, setColumnsChild] = useState([]);
  let [productId, setProductId] = useState();
  const modalWidthTitles = ['Batch Wise Production','Linewise Production', 'Return Center Binding','Loyalty']
  let [modalTitle, setModalTitle] = useState('');
  const [tpPermission, setTpPermission] = useState(null)
  let [modalWidth, setModalWidth] = useState();
  let [imagePath, setImagePath] = useState();
  let [table, setTable] = useState(false);
  const [selectOption, setSelectOption] = useState(0);
  const [selectedValue, setSelectedValue] = useState("");
  let [headers, setHeaders] = useState(null);
  const [wizardData, setWizardData] = useContext(WizardDataContext)
  const languages = [
    {
      code: 'en',
      name: 'English',
      country_code: 'gb',
    },
    {
      code: 'chi',
      name: '中国人',
      country_code: 'cn',
    }
  ];
  const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english'
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
  let [columns, setColumns] = useState([
    {
      dataField: "serial_no",
      text: "Serial No."
    },
    {
      dataField: "role_name",
      text: "Role Name"
    },
    {
      dataField: "customer_name",
      text: "Customer Name"
    }
  ]);
  const myRef = React.useRef(null);
  const columnsModified = columns.map((item) => {
    if(item.dataField !== 'template') {
    return {...item, formatter: (cell) => {
      if(cell == "NULL")
         return ""
     else
         return cell
    }
  }
} else {
  return {...item, formatter: (col, row) => { 
    return <span style={{ whiteSpace: 'normal', wordWrap: 'break-word'}}>{col}</span> }
  }
  }
  });
 
  let [formValues, setformValues] = useState();
  let [values, setValues] = useState();
  let [FilterformValues, setFilterformValues] = useState();
  let [ModalformValues, setModalformValues] = useState();
  let [localSearch, setLocalSearch] = useState(false);
  let [productsDataChild, setproductsDataChild] = useState([]);
  let [timelineData, setTimelineData] = useState({});
  const [direction, setDirection] = useState("vertical");
  let [timelineTitle, setTimelineTitle] = useState();
  const [showTPModal, setshowTPModal] = useState(false);
  const [showTimeline, setShowTimeline] = useState(false);
  const language = currentLanguageCode === 'en' ? 'english' : 'chinese'
  let [addPermission, setAddPermission] = useState(false)
  let [addPermission1, setAddPermission1] = useState(false)
  let [importPermission, setImportPermission] = useState(false)
  let [importPermission1, setImportPermission1] = useState(false)
  let [exportPermission, setExportPermission] = useState(false)
  let [exportPermission1, setExportPermission1] = useState(false)
  let [isLoader, setIsLoader] = useState(false);
  const [editId, setEditId] = useState(null)
  let [staticModalformValues, setStaticModalformValues] = useState();
  let [IOTLoyaltyQty, setIOTLoyaltyQty] = useState();
  const [iotQtyPermission, setIotQtyPermission] = useState(false)
  const [IOTLoyaltyQtyPermission, setIOTLoyaltyQtyPermission] = useState(false)
  const [IOTFlag, setIOTFlag] = useState(false)
  const [filterPermission, setFilterPermission] = useState(false)
  const [syncPermission, setSyncPermission] = useState(false);
  const [syncValue, setSyncValue] = useState(null);
  const [disableReloadIcon, setDisableReloadIcon] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [totalQuantities, setTotalQuanties] = useState([])
  const[loyaltyRedeem, setLoyaltyRedeem] = useState({});
  const [referenceValue, setReferenceValue] = useState("")
  const [completedRecord, setCompletedRecord] = useState(null)
  const [syncSapMessage, setSyncSapMessage] = useState({
    status: null,
    message: null
  })

  let dynamicParameters = {
   user_id:cookies.get('user_id'),
   customer_id:cookies.get('customer_id'),
   userLocation_id:cookies.get('userLocation_id'),
   userRole_name:cookies.get('userRole_name'),
   language: language
  }

  const validator = new SimpleReactValidator({
    autoForceUpdate: this,
    element: (message, className) => <div className="text-danger">{message}</div>
  });

  const formElementsArray = [];
  for (let key in ModalformValues) {
    formElementsArray.push({
      id: key,
      config: ModalformValues[key]
    });
  }



  const inputChangedHandler = (event, inputIdentifier) => {
    const updateOrderForm = {
      ...formValues
    }
    const updateElemetForm = {
      ...updateOrderForm[inputIdentifier]
    };

    updateElemetForm.value = event.target.value;
    updateOrderForm[inputIdentifier] = updateElemetForm;
    setformValues(updateOrderForm);
  }

  const buildModal = () => {
    setModalWidth(pageLayoutData[0].addButtonItems.className);
    setmodalType('Add');
    let bulidFormValues = {}
    let formvalues = Object.entries(pageLayoutData[0].addButtonItems.formValues)
    formvalues.forEach(([key, value]) => {
     if(key === 'platform' || key === 'version'){
      bulidFormValues[key] = value
     }
    });
    setModalformValues(bulidFormValues);
    setStaticModalformValues(pageLayoutData[0].addButtonItems.formValues)
    setModalTitle(pageLayoutData[0].addButtonName);
    setSaveUrl(pageLayoutData[1].subComponentsItems.saveApiEndPoint);
    setshowModal(true);
  }
  
  const editBuildModal = (event, id, extraId) => {
    setEditId(id)
    setModalTitle(pageLayoutData[0].addButtonName);
    setModalWidth(pageLayoutData[0].addButtonItems.className);
    let bulidFormValues = {}
    let formvalues = Object.entries(pageLayoutData[0].editButtonItems.formValues)
    formvalues.forEach(([key, value]) => {
     if(key === 'platform' || key === 'version'){
      bulidFormValues[key] = value
     }
    });
    setModalformValues(bulidFormValues);
    setStaticModalformValues(pageLayoutData[0].addButtonItems.formValues)
    let editURL = pageLayoutData[1].subComponentsItems.getApiEndPoint+ 
      '?id=' +id+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
      setmodalgetURL(editURL);
     setSaveUrl(pageLayoutData[1].subComponentsItems. updateEndApiPoint);
      setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id'));
    setmodalType('Edit');
    setuniqueId(id);
    setextraId(extraId);
    setshowModal(true);
  }


  async function buildDownload(e, value,hasFile) {
    setIsLoader(true);
    let fileList = []
    let docList = []
    const paramcomString = new URLSearchParams(dynamicParameters);
    const getURLChild = pageLayoutData[1].subComponentsItems.downloadApiEndPoint + '?id=' + value.id;
    let newgetURL = (`${getURLChild}&${paramcomString.toString()}`);
    const response1 = await FetchAPI(newgetURL);
    setIsLoader(false);
    const response1Json = await response1.json();
    let buildurl = response1Json.data['builddetails']
    Object.values(response1Json.data.docdetails).map((item => {
      if (item['file'] !== '')
        docList.push(item['file'])
    }))
    if (buildurl['url'] !== null) {
      fileList.push(buildurl['url'])
    }
    function download(fileList) {
        let url = fileList[0];
        let a = document.createElement("a");
        a.setAttribute('href', url);
        a.setAttribute('download', '');
        a.setAttribute('target', '_self');
        a.click();
    }
    if(hasFile && fileList.length !== 0){
      download(fileList)
      return;
    }
    
    if (docList.length !== 0){
      download(docList)
      return;
    }else{
      swal({
        text: "No release notes found for this build",
        icon: "warning",
    });
    }
  }

  async function syncInventory(e) {
    let getURL = pageLayoutData[1].subComponentsItems.syncApiEndPoint
    const customerId = cookies.get('customer_id');
    const location_id = cookies.get('userLocation_id');
    const user_role_name = cookies.get('userRole_name');
    const user_id = cookies.get('user_id');
    if(customerId == 15){
      const payload = {
        location_id,
        user_role_name,
        user_id
      }
      const paramsConverted = new URLSearchParams(payload);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
    }
    setIsLoader(true)
    setDisabledButton(true)
    let responseData = await FetchAPI(getURL);
    if(responseData.status === 200){
      let getresponseJson = await responseData.json()
      setDisabledButton(false)
      setIsLoader(false)
      getStatusAlert({status: getresponseJson?.Status,message: getresponseJson?.data,reCallGrid: getLatestTableData})
    }else{
      setDisabledButton(false)
      setIsLoader(false)
      getStatusAlert({status: 404,message:`${t("alerts.something_went_wrong1")}`,buttonText:`${t("alerts.ok")}`})
    }
  }
  const getSyncToSapGridColumns = (data) => {
    const columns = data.map(column => {
      let arr = []
      for (let key in column) {
        let keyText = key.split("_").join(" ").toUpperCase()
        arr.push({ dataField: key, text: keyText })
      }
      return [...arr]
    })
    setColumnsChild(columns[columns.length - 1]);
  }

  const modifySyncToSapJson = (inputJson) => {
    const title = pageLayoutData[1].title1;
    if (cookies.get('customer_id') == 15) {
      let Del_no, Plant, From_storageloc, Rec_storageloc
      if (title === "Dispatch Sync to" || title === "Receive GRN to") {
        const { del_no, plant } = inputJson[0];
        Del_no = del_no;
        Plant = plant;
      } else if (title === "Inventory Sync to") {
        const { plant, from_storageloc, rec_storageloc } = inputJson[0];
        Plant = plant;
        From_storageloc = from_storageloc;
        Rec_storageloc = rec_storageloc;
      }
      const mergedData = inputJson[0].data.map(item => {
        if (title === "Dispatch Sync to" || title === "Receive GRN to") {
          return {
            ...item,
            Del_no,
            Plant
          }
        }
        return {
          ...item,
          Plant,
          From_storageloc,
          Rec_storageloc,
        }
      });
      getSyncToSapGridColumns(mergedData)
      return mergedData
    } else {
      getSyncToSapGridColumns(inputJson)
      return inputJson;
    }
  }

  const handleSyncToSap = (value) => {
    setSyncSapMessage({
      status: value?.status,
      message: value?.message
    })
    const inputJson = JSON.parse(value.input)
    const result = modifySyncToSapJson(inputJson)
    setproductsDataChild(result);
    setModalTitle("List");
    setloadTableDataChild(true);
    setshowTPModal(true);
    setShowTimeline(false);
}

  const handleSyncReload = async(value) => {
    setSyncValue(value);
    setDisableReloadIcon(true);
  }

  const getSyncReload = async(value) => {
    const payloadObj = {
      id: value.id,
      delivery_id: value.delivery_id,
      reload: value.reload
    }
    setIsLoader(true)
    const response = await PostAPI(pageLayoutData[1].subComponentsItems.saveApiEndPoint,payloadObj)
    if(response.status === 200){
      setDisableReloadIcon(false)
      setIsLoader(false)
      getStatusAlert({status:response?.data?.Status,message: response?.data?.Message,reCallGrid:getLatestTableData})
    }else{
      setDisableReloadIcon(false)
      setIsLoader(false)
      getStatusAlert({status: 404,message:`${t("alerts.something_went_wrong1")}`,buttonText:`${t("alerts.ok")}`})
    }
  }

  const handleLoyaltyCompleted = (value) => {
    setCompletedRecord(value);
    const columns = [{
      dataField: "bank_name",
      text: "Bank Name"
    },{
      dataField: "account_holder_name",
      text: "Account Holder Name"
    },
    {
      dataField: "account_no",
      text: "Account Number"
    },
    {
      dataField: "ifsc_code",
      text: "IFSC Code"
    }
  ]

    const data = [{
      bank_name: value.bankDetails.bank_name,
      account_no: value.bankDetails.account_no,
      account_holder_name: value.bankDetails.account_holder_name,
      ifsc_code: value.bankDetails.ifsc_code
    }]
    setshowTPModal(true);
    setColumnsChild(columns);
    setproductsDataChild(data);
  }


  useEffect(() => {
    if(disableReloadIcon && syncValue !== null){
      getSyncReload(syncValue)
    }
  },[disableReloadIcon,syncValue])

  
  // common function for modalbox Actions
  async function modalActions(data){
    const IsSyncToSap = pageLayoutData[1].title1 === "Inventory Sync to" || pageLayoutData[1].title1 === "Dispatch Sync to" || pageLayoutData[1].title1 === "Receive GRN to";
    const isLoyaltyRedeem = pageLayoutData[1].title1 === 'Loyalty' && data.editPermission == true 
    for (let [key, value] of Object.entries(data.data)) {
      value.action = <div>
        {(isLoyaltyRedeem && value.status === "Processing") && <ButtonField color="info" key="ModalCLRBTN" submit={ (e) => editOpenModal(e, value.id,value?.loyalty_wallet_transaction_id, value?.reference_no, value?.loyalty_wallet_id, isLoyaltyRedeem) } BName={t("Process")} />}
        {(data?.approvePermission && value?.status === "Approved")  && <ButtonField color="info" key="ModalCLRBTN" submit={() => handleLoyaltyCompleted(value)} BName={t("Complete")} />}
        {(!isLoyaltyRedeem) && data.editPermission == true || data[`edit${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
          }Permission`] === true
          ? <a onClick={(e) => editOpenModal(e, value.id)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
        {data.editPasswordPermission == true || data[`edit${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
          }PasswordPermission`] === true ? <a onClick={(e) => OpenUpdatePswdModal(e, value.id)}><i className="fa fa-key"></i></a> : ''}
        {data.deletePermission == true || data[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
          }Permission`] === true 
          ? <a onClick={(e) => deleteOpenModal(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
           {value.download === true? <a onClick={ (e) => exportDownload(e, value) }><i className="fa fa-download-square-o fa-download"></i></a>: ''} 
         {(data.editExtraPermission ==  true) ? <a onClick={ (e) => editOpenModalExtra(e, value.id) }><i className="fa fa-info-circle-square-o fa-info-circle"></i></a>: ''}
         {IsSyncToSap && <i onClick={(e) => handleSyncToSap(value)} className={`fa fa-info-circle refresh-icon ${value.reload == 2 ? "refresh-warn" : ""}`}/>}
         {((value.reload == 0 || value.reload == 2) && (pageLayoutData[1].title1 === "Dispatch Sync to"
        || ((pageLayoutData[1].title1 === "Receive GRN to" || pageLayoutData[1].title1 === "Inventory Sync to") && cookies.get('customer_id') == 15)))
        && <i onClick={(e) => handleSyncReload(value)} className={`fa fa-refresh refresh-icon`} />
      }
          </div>;  
          if(value.fifo == 'Fifo Enabled'){
          value.mandatory = <div>
            <ToggleButton
                  inactiveLabel="Warning"
                  activeLabel="Error"
                  value={value.mandatory}
                  onClick={(e) => changeToggle(e, value, value.id)}
                  />
            </div>;
          }
        }
  }
  
  // common function for build actions
  async function buildActions(data){
    for (let [key, value] of Object.entries(data.data)) {
      value.action = <div>
       {value.edit == true || data[`edit${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
          }Permission`] === true
          ? <a onClick={(e) => editBuildModal(e, value.id)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
       {data.deletePermission == true  || data[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
          }Permission`] === true 
          ? <a onClick={(e) => deleteOpenModal(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
       {value.download === true ? <a onClick={ (e) => buildDownload(e, value,true) }><i className="fa fa-download-square-o fa-download"></i></a>: ''}
          </div>;  
      }
  }
  
  // common function for wizard actions
  async function wizardActions(data){
    for (let [key, value] of Object.entries(data.data)) {
      value.action = <div>
        {data.editPermission == true || data[`edit${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
          }Permission`] === true
          ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
        {data.deletePermission == true || data[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
          }Permission`] === true
          ? <a onClick={(e) => deleteOpenModal(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
            {value.download === true ? <a onClick={ (e) => exportDownload(e, value) }><i className="fa fa-download-square-o fa-download"></i></a>: ''} 
            {data.tpPermission == true  ?<a onClick={ (e) => iotOpenModal(e, value.action) }><span style={{color:'#33b5e5'}}>{value.action}</span></a>: ''} 
            {data.fqcPermission == true || data.pdiPermission == true|| data.viewListPermission  ? <a onClick={ (e) => viewListModal(e, value, value.action) }><span style={{color:'#33b5e5'}}>{value.action}</span></a>: ''} 
        </div>;
      if(value.image){
        value.image = <div>
         <img src={value.image} alt="no img" width="50" height="50" />
         </div>;
       }
       if(value.pdf){
        value.pdf = <div>
          <a onclick={(e) => exportPdf(e, value.pdf)}><i className="fa fa-download-square-o fa-download"></i></a>
         </div>;
       } 
    }
  }

  async function exportDownload(e,value) {
    setIsLoader(true)
    let payload = {
      "userLocation_id":cookies.get('userLocation_id'),
      "userRole_name":cookies.get('userRole_name'),
      "locationType":value.locationType,
      "productId":value.productId,
      "productGroup":value.productGroup,
      "locationId":value.locationId,
      "customer_id":cookies.get('customer_id'),
      "user_id": cookies.get('user_id'),
      "id":value.id,
      "language": currentLanguageCode === 'en' ? 'english' : 'chinese'
    }
    let URL = pageLayoutData[0].downloadApiEndPoint1
    if(JSON.stringify(values) === JSON.stringify({}) || values === undefined){
      payload = { ...payload, 'pack_type':value.pack_type, 'status' : value.status, 'po_number': null, 'date':value.created_date}
    }else{
      payload = { ...payload, 'pack_type':value.pack_type, 'status' : value.status, 'po_number': values['po_number'].value.label, 'date':value.created_date}
    }
    let response1 =  await PostAPI(URL, payload);
    setIsLoader(false)
    window.location.href = response1.data.data.Location
  }

  async function iotOpenModal(event, id) {
    setloadTableDataChild(false);
    let newgetURL = null;
    const paramcomString = new URLSearchParams(dynamicParameters);
    const getURLChild = pageLayoutData[1].subComponentsItems.levelIdsEndPoint+ '?id='+id.props.children[3].props.children.props.children;
    newgetURL = (`${getURLChild}&${paramcomString.toString()}`);
    const productDataValuesChild = await FetchAPI(newgetURL);
    const productDataValuesJsonChild = await productDataValuesChild.json();
    for (let [key, value] of Object.entries(productDataValuesJsonChild.data.data)) {        
      value.level_ids = <a onClick={ (e) => openTimeline(e, value.level_ids) }><span style={{color:'#33b5e5'}}>{value.level_ids}</span></a>;
    }
    setColumnsChild(productDataValuesJsonChild.data.columns);
    setproductsDataChild(productDataValuesJsonChild.data.data);
    setModalTitle(id.props.children[3].props.children.props.children);
    setloadTableDataChild(true);
    setshowTPModal(true);
    setShowTimeline(false);
  }

  async function viewListModal(event, value, title) {
    setloadTableDataChild(false);
    setIsLoader(true)
    let newgetURL = null;
    let totalParams = {}
    switch (pageLayoutData[1].title1) {
      case 'Final QC':
      case 'PDI':
        totalParams = {
          ...(pageLayoutData[1].title1 ===  'Final QC' && {'location': value.location_id}),
          'from_date': value.from_date,
          'to_date': value.to_date,
          ...(pageLayoutData[1].title1 ===  'PDI' && {
            'po_number': value.po_number,
            'product': value.product,
            'lot_number': value.lot_number
          })
        }
        break
      case 'Outward':
        totalParams = {
          'date': value.date,
          'product_id': value.product_id || undefined,
          'tp_id':value.tp_id
        }
        break
        case 'Batch Wise Production':
        case 'Linewise Production':
        totalParams = {
          'category_id':value.category_id,
          'po_number':value.po_number,
          ...(pageLayoutData[1].title1 === 'Linewise Production' ? {'production_line' : value.production_line} : {'batch_no':value.batch_no}),
          'location_id':value.location_id,
          'material_code':value.material_code,
          'date':value.ddate
        }
        break
        case 'Return Center Binding':
        totalParams = {
          'location_id':value.location_id,
          'material_code':value.material_code,
          'date':value.date
        }
        break
      default:
        break
    }
    totalParams = {...totalParams, ...dynamicParameters}
    const paramcomString = new URLSearchParams(totalParams);
    const getURLChild = pageLayoutData[1].subComponentsItems.levelIdsEndPoint
    newgetURL = (`${getURLChild}?${paramcomString.toString()}`);
    const productDataValuesChild = await FetchAPI(newgetURL);
    const productDataValuesJsonChild = await productDataValuesChild.json();
    setColumnsChild(productDataValuesJsonChild.data.columns);
    setproductsDataChild(productDataValuesJsonChild.data.data);
    setModalTitle(title.props.children[4].props.children.props.children)
    setIsLoader(false)
    setloadTableDataChild(true);
    setshowTPModal(true);
    setShowTimeline(false);
    if (Object.hasOwn(productDataValuesJsonChild.data, 'outputUrl')) {
      const outputUrl = productDataValuesJsonChild.data?.outputUrl?.Location;
      window.location.href = outputUrl;
    }
  }


  async function openTimeline(event, id) {
    setShowTimeline(false);
    let newgetURL = null;
    const paramcomString = new URLSearchParams(dynamicParameters);
    let getURL = pageLayoutData[1].subComponentsItems.trackHistoryEndPoint+ '?id='+id.props.children.props.children;
    newgetURL = (`${getURL}&${paramcomString.toString()}`);
    let graphDataVal = await FetchAPI(newgetURL);
    let graphDataValJson = await graphDataVal.json();
    setTimelineData(graphDataValJson.data);
    setTimelineTitle(id.props.children.props.children);
    setShowTimeline(true);
    myRef.current.scrollIntoView({
      behavior:"smooth",
    });
  }

  const closeTPModal = () => {
    setshowTPModal(false);
  }

  async function searchTableData(data) {
    setloadTableData(false);
    let startFrom = 0;
    let cpage = 0
    let searchFormData = {};
    let title1 = i18n.language == "chi" ? pageLayoutData[1].title1En : pageLayoutData[1].title1
    let totalParams;
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    totalParams = {...totalParams, ...dynamicParameters}
    for (let formElementIdentifier in data) {
       if(data[formElementIdentifier].elementType === 'multiselect') {
        if((data[formElementIdentifier].value)) {
          let arrayConvert = [];
          data[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
        else if(data[formElementIdentifier].elementType === 'selectshowsearch'){
          searchFormData[formElementIdentifier] = data[formElementIdentifier].value.label;
        }
      else
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
    }
      totalParams.start_from = startFrom;
    let newObj = { ...searchFormData, ...totalParams}
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined );
      else if(titlesList.includes(title1) == true) {
      getURL = getURL;
      setsearchInputValue('')
      }
      else{
      getURL = getURL + '&element=' + searchInputValue;
      }
      let responseData = await FetchAPI(getURL);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
          if(!isEmpty(responseDataJson.data.data)) {
            setAddButtonPermission(responseDataJson.data.addPermission)
            setFilteredCondition(responseDataJson.data.filterCondition)
            setSelectOption(
              Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
            );
            if(pageLayoutData[0].addButtonType == 'modal') {
              modalActions(responseDataJson.data)
                }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                  buildActions(responseDataJson.data)
                }else {
                  wizardActions(responseDataJson.data)
             }
          }
        setpage(1);
        setSelectedValue(1);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setIotQty(responseDataJson.data.IOTQty)
        setRevertQty(responseDataJson.data.revertCount)
        setQty(responseDataJson.data.Qty)
        setloadTableData(true);
        setIOTLoyaltyQty(responseDataJson.data.IOTLoyaltyQty)
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setTpPermission(responseDataJson.data?.tpPermission)
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }  
    }
    else {
      let newestObj;
      newestObj = {...newObj}
      if(!setsearchInputValue || searchInputValue === undefined);
      else if(titlesList.includes(title1) == true) {
      getURL = getURL;
      setsearchInputValue('')
      }
      else{
      newestObj = {...newObj, element:searchInputValue}
      }
      let responseData = await PostAPI(getURL, newestObj);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          setFilteredCondition(responseDataJson.data.filterCondition)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
              }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                buildActions(responseDataJson.data)
              }else {
                wizardActions(responseDataJson.data)
           }
        }
        setpage(1);
        setSelectedValue(1);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
        setTpPermission(responseDataJson.data?.tpPermission)
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
  }

  async function filteredExport(data) {
    setIsFilterLoader(true);
    let arr = Object.values(data);
    const featuresObj = JSON.parse(localStorage.newSidebar);
    const featuresList = featuresObj.data.features
    let titlesList  = [];
    featuresList.map(el => {
      if(el.name === 'D2C Reports'){
        el.submenuitem.map(el => {
          titlesList.push(el.name)
        })
      }
    })
    let title1 = i18n.language == "chi" ? pageLayoutData[1].title1En : pageLayoutData[1].title1
    let title2 = i18n.language == "chi" ? pageLayoutData[1].title2En : pageLayoutData[1].title2
    let combinedTitle = `${title1} ${title2}`
    let valueNull = arr.some((el) => el.value !== null)
    let datesNull = true;
    Object.keys(data).forEach(el => {
      if(el==='from_date' || el==='to_date'){
        if(data[el].value === null)
          datesNull = false
      }
    })
    let searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[0].exportApiEndPoint;
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name'),
      language: currentLanguageCode === 'en' ? 'english' : 'chinese'
    }
    totalParams = {...totalParams, ...requiredValues}
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    for (let formElementIdentifier in data) {
      if(data[formElementIdentifier].elementType === 'multiselect') {
        if((data[formElementIdentifier].value)) {
          let arrayConvert = [];
          let stringValues = []
          data[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
            stringValues[indexId] = fValue.value
          });
          searchFormData[formElementIdentifier] = title1 === 'Weighing' ? stringValues.join(",") : arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
        else if(data[formElementIdentifier].elementType === 'selectshowsearch'){
          if((data[formElementIdentifier].value)) 
            searchFormData[formElementIdentifier] = data[formElementIdentifier].value.value;
          else
          searchFormData[formElementIdentifier] = null
        }
      else
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
    }
    let newObj = { ...searchFormData, ...totalParams}
    let responseData,getresponseJson;
    if((titlesList.includes(combinedTitle) || title1 === 'Generated IOT History') && pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        if(datesNull){
          let paramsConverted = new URLSearchParams(newObj);
          getURL = (`${getURL}?${paramsConverted.toString()}`);
          responseData = await FetchAPI(getURL);
          getresponseJson = await responseData.json()
        }else{
          setIsFilterLoader(false);
          return swal({
            title:`${t("alerts.choose_valid_dates")}`, 
            text:combinedTitle,
            icon:"warning", button:`${t("alerts.ok")}`
          })
        }
    }
    else if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET' && title1 !== 'Weighing') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      responseData = await FetchAPI(getURL);
      getresponseJson = await responseData.json()
    }else if(valueNull === false && pageLayoutData[1].subComponentsItems.apiEndPointType === 'POST') {
      setIsFilterLoader(false)
      if(cookies.get("customer_id") === "15" && title1 === "Production"){
        setIsFilterLoader(true);
        responseData = await PostAPI(getURL, newObj);
        setIsFilterLoader(false);
      }else{
      return swal({
        title:`${t("alerts.choose_any_field")}`, 
        text: combinedTitle, 
        icon:"warning", 
        button:`${t("alerts.ok")}`
      })
    }
    }else{
      responseData = await PostAPI(getURL, newObj);
      if((cookies.get('customer_id') === "13" && title1 === 'Scrap')) {
        window.location.href = responseData.data.data?.Location
      }
    }
    if(title1 !== 'Supplier Inventory' && getresponseJson?.data.Status == 409){
      setIsFilterLoader(false)  
      swal(getresponseJson.data.Message.replace(/\w\S*/g, function(t) { return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase(); }),{
        icon: "info",
        buttons: `${t('alerts.ok')}`,
        dangerMode: true,
      })
    }
    else if(responseData.status == 200 && cookies.get('customer_id') !== "12"){
      setIsFilterLoader(false)
      swal({
        title:`${t("alerts.your_request_under_process")}`, 
        text:`${t("alerts.receive_email")}`, 
        icon:"success", 
        button:`${t("alerts.ok")}`
      })
      if(cookies.get('customer_id') === "15"){
        if(responseData.data.data?.Location){
        window.location.href = responseData.data.data?.Location
        }
        else if(responseData.data.data?.Status === 409){
          let msg = responseData.data.data?.Message;
          return swal(msg.replace(/\w\S*/g, function(t) { return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase(); }),{
            icon: "info",
            buttons: `${t('alerts.ok')}`,
            dangerMode: true,
          })
        }
      }
  }else if(responseData.status == 200 && cookies.get('customer_id') === "12" && (title1 === "IOT" || title2 === 'Report' || title1 === 'Un-Bind')){
    setIsFilterLoader(false)
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET'&& title1 !== 'Weighing') {
      window.location.href = getresponseJson.data.Location
    }else{
      window.location.href = responseData.data.data.Location
    }
  }
      else{
      setIsFilterLoader(false)
      swal({
        title:`${t("alerts.something_went_wrong1")}`, 
        text:`${t("alerts.download_again")}`, 
        icon:"error", 
        button:`${t("alerts.ok")}`
      })
      }
  }
  async function filteredExport1(data) {
    setIsFilterLoader(true)
    setDisabledButton(true)
    let arr = Object.values(data);
    let valueNull = arr.some((el) => el.value !== null)
    let datesNull = true;
    Object.keys(data).forEach(el => {
      if(el==='from_date' || el==='to_date'){
        if(data[el].value === null)
          datesNull = false
      }
    })
    let searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[0].exportApiEndPoint1;
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name'),
      language: currentLanguageCode === 'en' ? 'english' : 'chinese'
    }
    totalParams = {...totalParams, ...requiredValues}
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    for (let formElementIdentifier in data) {
      if(data[formElementIdentifier].elementType === 'multiselect') {
        if((data[formElementIdentifier].value)) {
          let arrayConvert = [];
          data[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
      else if(data[formElementIdentifier].elementType === 'selectshowsearch'){
        if((data[formElementIdentifier].value)){
          searchFormData[formElementIdentifier] = data[formElementIdentifier].value?.value
          }
      }
      else
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
    }
    let newObj = { ...searchFormData, ...totalParams}
    let responseData,getresponseJson;
    let title1 = i18n.language == "chi" ? pageLayoutData[1].title1En : pageLayoutData[1].title1
    let title2 = i18n.language == "chi" ? pageLayoutData[1].title2En : pageLayoutData[1].title2
    let combinedTitle = `${title1} ${title2}`
    if(pageLayoutData[0].hasOwnProperty('exportFilterButtonName1') === true && pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        if(datesNull){
          let paramsConverted = new URLSearchParams(newObj);
          getURL = (`${getURL}?${paramsConverted.toString()}`);
          responseData = await FetchAPI(getURL);
          getresponseJson = await responseData.json()
        }else{
            setIsFilterLoader(false)
            setDisabledButton(false)
          return swal({
            title:`${t("alerts.choose_valid_dates")}`, 
            text: combinedTitle,
            icon:"warning", button:`${t("alerts.ok")}`
          })
        }
    }
    else if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET' && title1 !== 'Linewise Production' && title1 !== 'Weighing') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      responseData = await FetchAPI(getURL);
      getresponseJson = await responseData.json()
    }else if(valueNull === false && pageLayoutData[1].subComponentsItems.apiEndPointType === 'POST') {
      setIsFilterLoader(false);
      setDisabledButton(false)
      if(cookies.get("customer_id") === "15" && title1 === "Production"){
        setIsFilterLoader(true);
        responseData = await PostAPI(getURL, newObj);
        setIsFilterLoader(false);
      }else{
      return swal({
        title:`${t("alerts.choose_any_field")}`, 
        text: combinedTitle, 
        icon:"warning", 
        button:`${t("alerts.ok")}`
      })
    }
    }else {
      responseData = await PostAPI(getURL, newObj);
    }
    if(title1 !== 'Supplier Inventory' && getresponseJson?.data?.Status == 409){
      setDisabledButton(false)
      setIsFilterLoader(false)
      swal(getresponseJson.data.Message.replace(/\w\S*/g, function(t) { return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase(); }),{
        icon: "info",
        buttons: `${t('alerts.ok')}`,
        dangerMode: true,
      })
    }
    else if(responseData.status == 200 && cookies.get('customer_id') !== "12"){
      setDisabledButton(false)
      setIsFilterLoader(false)
      swal({
        title:`${t("alerts.your_request_under_process")}`, 
        text:`${t("alerts.receive_email")}`, 
        icon:"success", 
        button:`${t("alerts.ok")}`
      })
      if(cookies.get('customer_id') === "15" || cookies.get('customer_id') === "13"){
        if(responseData.data.data?.Location){
          window.location.href = responseData.data.data?.Location
        }
        else if(responseData.data.data?.Status === 409){
          let msg = responseData.data.data?.Message;
          return swal(msg.replace(/\w\S*/g, function(t) { return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase(); }),{
            icon: "info",
            buttons: `${t('alerts.ok')}`,
            dangerMode: true,
          })
        }
      }
  }else if(responseData.status == 200 && cookies.get('customer_id') === "12" && (title1 === "IOT" || title2 === 'Report')){
    setDisabledButton(false)
    setIsFilterLoader(false)
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      window.location.href = getresponseJson.data.Location
    }else{
      window.location.href = responseData.data.data.Location
    }
  }
      else{
    setDisabledButton(false)
    setIsFilterLoader(false)
        swal({
          title:`${t("alerts.something_went_wrong1")}`, 
          text:`${t("alerts.download_again")}`, 
          icon:"error", 
          button:`${t("alerts.ok")}`
        })
      }
  }
  function filteredExport2(data) {
    setValues(data)
  }
  async function clearTableData(event) {
    setloadTableData(false)
    let totalParams;
    let title1 = i18n.language == "chi" ? pageLayoutData[1].title1En : pageLayoutData[1].title1
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
      const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
      totalParams = {...totalParams, ...firstTimeParameters}
    }
    totalParams = {...totalParams, ...dynamicParameters}
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(totalParams);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined )
      getURL = getURL;
      else
      getURL = getURL + '&element=' + searchInputValue;
      let responseData = await FetchAPI(getURL);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          setFilteredCondition(responseDataJson.data.filterCondition)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
              }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                buildActions(responseDataJson.data)
              }else {
                wizardActions(responseDataJson.data)
           }
        }
        setpage(1);
        setSelectedValue(1);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setformValues(pageLayoutData[0].formValues);
        setIotQty(responseDataJson.data.IOTQty)
        setRevertQty(responseDataJson.data.revertCount)
        setIOTLoyaltyQty(responseDataJson.data.IOTLoyaltyQty)
        setQty(responseDataJson.data.Qty)
        setValues(values={});
        setshowFilter(!showFilter);
        setloadTableData(true);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setTpPermission(responseDataJson.data?.tpPermission)
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }  
    }
    else {
      let newestObj;
      if(!setsearchInputValue || searchInputValue === undefined )
      newestObj = {...totalParams}
      else
      newestObj = {...totalParams, element:searchInputValue}
      let responseData = await PostAPI(getURL, newestObj);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          setFilteredCondition(responseDataJson.data.filterCondition)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
              }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                buildActions(responseDataJson.data)
              }else {
                wizardActions(responseDataJson.data)
           }
        }
        setpage(1);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
        setformValues(pageLayoutData[0].formValues);
        setshowFilter(!showFilter);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setTpPermission(responseDataJson.data?.tpPermission)
        setValues(values={});
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
  }

  const handleTableChange = (event, { page, sizePerPage }) => {
    if (event == 'search') {
      return;
    }
    const currentIndex = (page - 1) * sizePerPage;
    setpage(page);
    setsizePerPage(sizePerPage);
    handlePageChange(page);
  }

  const MySearch = (props) => {
    let input;
    const changeInputFunction = (e,input) => {
      if(e.which === 13){
        handleClick();
      }

      if(e.which === 32 && !input.value.length)
      swal({
        title:`${t("alerts.spaces_not_allowed")}`, 
        text:`${t("alerts.search_is_restricted")}`, 
        icon:"warning", 
        button:`${t("alerts.ok")}`
      }) 
    }
       const clearchangeInputFunction = (e,input) => {
        if(e.which === 8 && input.value.length === 1){
          clearSearchData(e);
        }
  }
  
    
    const handleClick = async () => {
      if(input.value == ''){
      swal({
        title:`${t("alerts.enter_search")}`, 
        text:`${t("alerts.value_to_search")}`, 
        icon:"warning", 
        button:`${t("alerts.ok")}`
      }) 
        return false;
      }
      setloadTableData(false);
      props.onSearch(input.value);
      setsearchInputValue(input.value);
      let totalParams;
      let startFrom = 0;
      let searchFormData = {};
      let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
      if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
        const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
        totalParams = {...totalParams, ...extraParameteres}
      } 
      totalParams= {...totalParams, start_from: startFrom, ...dynamicParameters}
      for (let formElementIdentifier in values) {
         if(values[formElementIdentifier].elementType === 'multiselect') {
          if((values[formElementIdentifier].value)) {
            let arrayConvert = [];
            values[formElementIdentifier].value.map(function(fValue, indexId){
              arrayConvert[indexId] = fValue.value;
            });
            searchFormData[formElementIdentifier] = arrayConvert;
          }
          else
            searchFormData[formElementIdentifier] = null;
          }
        else
          searchFormData[formElementIdentifier] = values[formElementIdentifier].value;
      }
      totalParams = {...totalParams, element:input.value.replace(/^\s+|\s+$/gm,'')}
      let newObj = { ...searchFormData, ...totalParams}
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        let paramsConverted = new URLSearchParams(newObj);
        getURL = (`${getURL}?${paramsConverted.toString()}`);
        let responseData = await FetchAPI(getURL);
        if(responseData.status == 200){
          setError(false);
          let responseDataJson = await responseData.json();
          if(pageLayoutData[1].title1==="Build/Software(s)"){
            for (let [key, value] of Object.entries(responseDataJson.data.data)) {        
              value.release_notes = <div>
                <div onClick={(e) => buildDownload(e, value) } className="download-icon" >Document</div>
                </div>;
            }}
          if(!isEmpty(responseDataJson.data.data)) {
            setAddButtonPermission(responseDataJson.data.addPermission)
            setFilteredCondition(responseDataJson.data.filterCondition)
            if(pageLayoutData[0].addButtonType == 'modal') {
              modalActions(responseDataJson.data)
                }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                  buildActions(responseDataJson.data)
                }else {
                  wizardActions(responseDataJson.data)
             }
          }
          setpage(1);
          setSelectedValue(1);
          setColumns(responseDataJson.data.columns);
          getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
          setproductsData(responseDataJson.data.data);
          setformValues(pageLayoutData[0].formValues);
          setQty(responseDataJson.data.Qty)
          settotalrecords(responseDataJson.data.recordsTotal);
          setshowCSearch(true);
          setloadTableData(true);
          setIOTLoyaltyQty(responseDataJson.data.IOTLoyaltyQty)
          setSelectOption(
            Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
          );
          setTpPermission(responseDataJson.data?.tpPermission)
        }
        else {
          setloadTableData(false);
          setError(true);
          setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
        }  
      }
      else {
        let responseData = await PostAPI(getURL, newObj);
        if(responseData.status == 200){
          setError(false);
          let responseDataJson = responseData.data;
          if(!isEmpty(responseDataJson.data.data)) {
            setAddButtonPermission(responseDataJson.data.addPermission)
            setFilteredCondition(responseDataJson.data.filterCondition)
            if(pageLayoutData[0].addButtonType == 'modal') {
              modalActions(responseDataJson.data)
                }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                  buildActions(responseDataJson.data)
                }else {
                  wizardActions(responseDataJson.data)
             }
          }
          setpage(1);
          setSelectedValue(1);
          setColumns(responseDataJson.data.columns);
          getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
          setproductsData(responseDataJson.data.data);
          setformValues(pageLayoutData[0].formValues);
          settotalrecords(responseDataJson.data.recordsTotal);
          setshowCSearch(true);
          setloadTableData(true);
          setSelectOption(
            Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
          );
          setTpPermission(responseDataJson.data?.tpPermission)
        }
        else {
          setloadTableData(false);
          setError(true);
          setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
        }
      }
    }
    async function clearSearchData(event) {
      setloadTableData(false);
      event.preventDefault();
      let totalParams;
      let startFrom= 0;
      let cpage;
    let title1 = i18n.language == "chi" ? pageLayoutData[1].title1En : pageLayoutData[1].title1
      let searchFormData={};
      let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
      if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
        const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
        totalParams = {...totalParams, ...extraParameteres}
      }     
        totalParams = {...totalParams, start_from: startFrom}
      for (let formElementIdentifier in values) {
        if(values[formElementIdentifier].elementType === 'multiselect') {
          if((values[formElementIdentifier].value)) {
            let arrayConvert = [];
            values[formElementIdentifier].value.map(function(fValue, indexId){
              arrayConvert[indexId] = fValue.value;
            });
            searchFormData[formElementIdentifier] = arrayConvert;
          }
          else
            searchFormData[formElementIdentifier] = null;
          }
        else
          searchFormData[formElementIdentifier] = values[formElementIdentifier].value;
      }
      totalParams = {...totalParams, ...dynamicParameters, ...searchFormData}
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        let paramsConverted = new URLSearchParams(totalParams);
        getURL = (`${getURL}?${paramsConverted.toString()}`);
        setsearchInputValue();
        let responseData = await FetchAPI(getURL);
        if(responseData.status == 200){
          setError(false);
          let responseDataJson = await responseData.json();
          if(pageLayoutData[1].title1==='Build/Software(s)'){
            for (let [key, value] of Object.entries(responseDataJson.data.data)) {        
              value.release_notes = <div>
                <div onClick={(e) => buildDownload(e, value) } className="download-icon" >Document</div>
                </div>;
            }}
          if(!isEmpty(responseDataJson.data.data)) {
            setAddButtonPermission(responseDataJson.data.addPermission)
            setFilteredCondition(responseDataJson.data.filterCondition)
            setSelectOption(
              Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
            );
            if(pageLayoutData[0].addButtonType == 'modal') {
              modalActions(responseDataJson.data)
                }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                  buildActions(responseDataJson.data)
                }else {
                  wizardActions(responseDataJson.data)
             }
          }
          setpage(1);
          setSelectedValue(1)
          setColumns(responseDataJson.data.columns);
          getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
          setproductsData(responseDataJson.data.data);
          setformValues(pageLayoutData[0].formValues);
          settotalrecords(responseDataJson.data.recordsTotal);
          setIOTLoyaltyQty(responseDataJson.data.IOTLoyaltyQty)
          setTpPermission(responseDataJson.data?.tpPermission)
          setQty(responseDataJson.data.Qty)
          setsearchInputValue();
          setshowCSearch(false);
          setloadTableData(true);
        }
        else {
          setloadTableData(false);
          setError(true);
          setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
        }  
      }
      else {
       setsearchInputValue();
        let responseData = await PostAPI(getURL, totalParams);
        if(responseData.status == 200){
          setError(false);
          let responseDataJson = responseData.data;
          if(!isEmpty(responseDataJson.data.data)) {
            setAddButtonPermission(responseDataJson.data.addPermission)
            setFilteredCondition(responseDataJson.data.filterCondition)
            if(pageLayoutData[0].addButtonType == 'modal') {
              modalActions(responseDataJson.data)
                }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                  buildActions(responseDataJson.data)
                }else {
                  wizardActions(responseDataJson.data)
             }
          }
          setpage(1);
          setSelectedValue(1);
          setColumns(responseDataJson.data.columns);
          getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
          setproductsData(responseDataJson.data.data);
          setformValues(pageLayoutData[0].formValues);
          settotalrecords(responseDataJson.data.recordsTotal);
          setsearchInputValue();
          setshowCSearch(false);
          setloadTableData(true);
          setSelectOption(
            Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
          );
          setTpPermission(responseDataJson.data?.tpPermission)
        }
        else {
          setloadTableData(false);
          setError(true);
          setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
        }
      }
    };
    return (
      <div>
        <MDBCol md="4" className="mb-4">
          <input
            onKeyPress={(e) => changeInputFunction(e,input)}
            onKeyDown={(e) => clearchangeInputFunction(e,input)}
            className="form-control"
            style={{ backgroundColor: 'white' }}
            placeholder={`${t("search")}`}
            ref={n => input = n}
            type="text"
            defaultValue={searchInputValue}
          />
        </MDBCol>
        <MDBCol md="4" className="mb-4">
          {/* {(showCSearch == false) && <ButtonField color="info" key="ModalCLRBTN" submit={ handleClick } BName="Search" /> }  */}
          {<ButtonField color="info" key="ModalCLRBTN" submit={ handleClick } BName={t("search")} /> } 
          {(showCSearch == true) && <ButtonField color="info" key="ModalCLRBTN" submit={ (e) => clearSearchData(e) } BName={t("clear")} />} 
        </MDBCol>
        
        {IOTFlag ? 
        <MDBCol md="4" className="mb-4" style={{display: "flex",justifyContent: "end"}} >
            {(pageLayoutData[0].addButton === true && addButtonPermission == true && pageLayoutData[0].addButtonType == 'modal' && pageLayoutData[1].title1 === 'Un-Bind' ? <ButtonField color="info" submit={() => open()} BName={t(pageLayoutData[0].addButtonName) } /> 
                : ((pageLayoutData[0].addButton === true && addButtonPermission == true && pageLayoutData[0].addButtonType == 'modal') ? 
                <ButtonField color="info" submit={() => open()} BName={t(pageLayoutData[0].addButtonName) } /> : '') || (addPermission1 === true && pageLayoutData[0].addButtonType == 'modal' ? <ButtonField color="info" submit={() => open()} BName={t(pageLayoutData[0].addButtonName) } /> : ''))} 
          {(pageLayoutData[0].filterStatus === true) && filterPermission ? <ButtonField color="info" key="Filter" submit={() => openFilter()} BName={t("filter")} /> : ''}  
        </MDBCol>
        :
        <MDBCol md="1" className="mb-1"></MDBCol>}
      </div>
    );
  };

  async function handleLatestTableData(page) {
    setloadTableData(false);
    let startFrom = 0;
    let cpage = 0
    let title1 = i18n.language == "chi" ? pageLayoutData[1].title1En : pageLayoutData[1].title1
    const searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    totalParams = {...totalParams, ...dynamicParameters}
    for (let formElementIdentifier in values) {
      if(values[formElementIdentifier].elementType === 'multiselect') {
        if((values[formElementIdentifier].value)) {
          let arrayConvert = [];
          values[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
      else
        searchFormData[formElementIdentifier] = values[formElementIdentifier].value;
    }
    if(page == 1) {
      let startFrom = 0;
      totalParams.start_from = startFrom;
    }else {
      cpage = page -1;
      startFrom = cpage * sizePerPage;
      totalParams.start_from = startFrom;
    }
    let newObj = { ...searchFormData, ...totalParams}
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined ){
      getURL = getURL + '&index=' + page;
      }
      else{
      getURL = getURL + '&element=' + searchInputValue+'&index=' + page;
      }
      let responseData = await FetchAPI(getURL);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        if(pageLayoutData[1].title1==='Build/Software(s)'){
          for (let [key, value] of Object.entries(responseDataJson.data.data)) {        
            value.release_notes = <div>
              <div onClick={(e) => buildDownload(e, value) } className="download-icon" >Document</div> 
               </div>;
          }}
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          setFilteredCondition(responseDataJson.data.filterCondition)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
              }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                buildActions(responseDataJson.data)
              }else {
                wizardActions(responseDataJson.data)
           }
        }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setIotQty(responseDataJson.data.IOTQty)
        setIOTLoyaltyQty(responseDataJson.data.IOTLoyaltyQty)
        setRevertQty(responseDataJson.data.revertCount)
        setQty(responseDataJson.data.Qty)
        setloadTableData(true);
        setTpPermission(responseDataJson.data?.tpPermission)
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }  
    }
    else {
      let newestObjSearch;
      let newestObj = {...newObj, index:page}
      if(!setsearchInputValue || searchInputValue === undefined )
      newestObjSearch = {...newestObj}
      else
      newestObjSearch = {...newestObj, element:searchInputValue}
      let responseData = await PostAPI(getURL, newestObjSearch);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          setFilteredCondition(responseDataJson.data.filterCondition)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
              }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                buildActions(responseDataJson.data)
              }else {
                wizardActions(responseDataJson.data)
           }
        }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
        setTpPermission(responseDataJson.data?.tpPermission)
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
  }

  async function getLatestTableData() {
    setformValues(pageLayoutData[0].formValues);
    setshowFilter(false)
    setloadTableData(false);
    setsearchInputValue();
    setshowCSearch(false);
    let totalParams;
    let title1 = i18n.language == "chi" ? pageLayoutData[1].title1En : pageLayoutData[1].title1
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
      const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
      totalParams = {...totalParams, ...firstTimeParameters}
    }
    totalParams = {...totalParams, ...dynamicParameters}

    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(totalParams);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      getURL = getURL + '&index=' + page;
      let responseData = await FetchAPI(getURL);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        if(pageLayoutData[1].title1==='Build/Software(s)'){
          for (let [key, value] of Object.entries(responseDataJson.data.data)) {        
            value.release_notes = <div>
                <div onClick={(e) => buildDownload(e, value) } className="download-icon" >Document</div>
              </div>;
          }}
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          setFilteredCondition(responseDataJson.data.filterCondition)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
              }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                buildActions(responseDataJson.data)
              }else {
                wizardActions(responseDataJson.data)
           }
        }
        setpage(1);
        setSelectedValue(1);
        setColumns(responseDataJson.data.columns);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setIotQty(responseDataJson.data.IOTQty)
        setIOTLoyaltyQty(responseDataJson.data.IOTLoyaltyQty)
        setRevertQty(responseDataJson.data.revertCount)
        setQty(responseDataJson.data.Qty)
        setloadTableData(true);
        setTpPermission(responseDataJson.data?.tpPermission)
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }  
    }
    else {
      let newObj = {...totalParams, index:page}
      let responseData = await PostAPI(getURL, newObj);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          setFilteredCondition(responseDataJson.data.filterCondition)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
              }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                buildActions(responseDataJson.data)
              }else {
                wizardActions(responseDataJson.data)
           }
        }
        setpage(1);
        setColumns(responseDataJson.data.columns);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setTpPermission(responseDataJson.data?.tpPermission)
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
  }

  async function delelteData(URL) {
    setIsLoader(true);
    const getresponse = await FetchAPI(URL);
    const getresponseJson = await getresponse.json();
    setIsLoader(false);
    const responseData = getresponseJson.data;
  }

  const openFilter = () => {
    setshowFilter(!showFilter);
    let URL= pageLayoutData[0].hasOwnProperty('filterEndPoint') ? 
            pageLayoutData[0].filterEndPoint: 'not found'
    let totalParams={};
    if(pageLayoutData[0].extraParametersDropdown !== null) {
      const extraParametersDropdown = pageLayoutData[0].extraParametersDropdown;
      totalParams = {...totalParams, ...extraParametersDropdown}
    }
    totalParams = {...totalParams, ...dynamicParameters}
    if(URL !== 'not found') {
    let paramsConverted = new URLSearchParams(totalParams);
    URL = (`${URL}?${paramsConverted.toString()}`);
    setDropDownApi(URL);
    }else 
    setDropDownApi('not found')
  }

  const open = () => {
    setuniqueId();
    setModalWidth(pageLayoutData[0].addButtonItems.className);
    setmodalType(`${ pageLayoutData[0].addButtonName === "Assign IOTs" || pageLayoutData[0].addButtonName === "Download IOTs" || pageLayoutData[0].addButtonName === "UnBind Serial Number" ? "" : t('add')}`);
    setUnBindUrl(pageLayoutData[1].subComponentsItems.saveApiEndPoint)
    setModalTitle(pageLayoutData[0].addButtonName);
    setModalformValues(pageLayoutData[0].addButtonItems.formValues);
    setSaveUrl(pageLayoutData[0].addButtonItems.saveApiEndPoint);
    i18n.language === "chi" ? setCommonTitle(pageLayoutData[0].addButtonNameEn) : setCommonTitle(pageLayoutData[0].addButtonName)
    setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language);
    setshowModal(true);
    (pageLayoutData[0].addButtonItems.hasOwnProperty('Table') ? 
        setTable(pageLayoutData[0].addButtonItems.Table) : 
        setTable(false));
      (pageLayoutData[0].addButtonItems.hasOwnProperty('headers') ? 
          setHeaders(pageLayoutData[0].addButtonItems.headers) : 
          setHeaders(null));
  }
  const openImport = () => {
    setmodalType(`${t("import")}`);
    setModalTitle(pageLayoutData[0].importButtonName);
    setModalformValues(pageLayoutData[0].importButtonItems.formValues);
    setSaveUrl(pageLayoutData[0].importButtonItems.saveApiEndPoint);
    setshowModal(true);
    setDropDownApi("not found")
    setModalWidth(pageLayoutData[0].importButtonItems?.className);
  }
  const openImport1 = () => {
    setmodalType(`${t("import")}`);
    setModalTitle(pageLayoutData[0].importButtonName1);
    setModalformValues(pageLayoutData[0].importButtonItems1.formValues);
    setSaveUrl(pageLayoutData[0].importButtonItems1.saveApiEndPoint);
    setshowModal(true);
  }

  const close = () => {
    setshowModal(false);
  }

  const OpenUpdatePswdModal = (event, id) => {
    setmodalType(`${t('update')}`);
    setModalTitle(`${t('password')}`)
    setextraId('Password');
     setModalformValues(pageLayoutData[0].updatePwdButtonItems.formValues);
    setSaveUrl(pageLayoutData[0].updatePwdButtonItems.saveApiEndPoint);
    setshowModal(true);
    setuniqueId(id);
    setModalWidth("modal-60w")
    setDropDownApi("not found")
  }
  const editOpenModalExtra = (event, id) => {
    setmodalType(`${t('edit')}`);
    setModalTitle(pageLayoutData[0].addButtonExtraName);
    setModalformValues(pageLayoutData[0].editButtonExtraItems.formValues);
    setuniqueId(id);
    setmodalgetURL(pageLayoutData[0].editButtonExtraItems.getApiEndPoint+'?id='+id);
    setSaveUrl(pageLayoutData[0].editButtonExtraItems.saveApiEndPoint);
    (pageLayoutData[0].editButtonExtraItems.hasOwnProperty('Table') ? 
    setTable(pageLayoutData[0].editButtonExtraItems.Table) : 
    setTable(false));
    (pageLayoutData[0].editButtonExtraItems.hasOwnProperty('editHeaders') ? 
    setHeaders(pageLayoutData[0].editButtonExtraItems.editHeaders) : 
    setHeaders(null));
    setshowModal(true);
  }

  const editOpenModal = (event, id, extraId,referenceNo, loyaltyId, IsloyaltyRedeem) => {
    setModalTitle(pageLayoutData[0].addButtonName);
    (pageLayoutData[0].editButtonItems !== undefined ? setModalformValues(pageLayoutData[0].editButtonItems.formValues) : setModalformValues(pageLayoutData[0].addButtonItems.formValues));
    {(pageLayoutData[0].editButtonItems.hasOwnProperty('updateApi') === true) ? setSaveUrl(pageLayoutData[0].editButtonItems.saveApiEndPoint) : setSaveUrl(pageLayoutData[0].addButtonItems.saveApiEndPoint)};
    const loyaltyProperties = IsloyaltyRedeem ? {
      loyaltytransactionid: extraId,
      referenceNo,
      loyaltyWalletId: loyaltyId
      } : null;
    let editURL = '';

      editURL = pageLayoutData[1].subComponentsItems.getApiEndPoint+ 
      '?id=' +id+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language;
      setmodalgetURL(editURL);
      setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&language='+language);
    setModalWidth(pageLayoutData[0].editButtonItems.className);
    setmodalType(`${t('edit')}`);
    setLoyaltyRedeem(loyaltyProperties);
    setuniqueId(id);
    setextraId(extraId);
    setshowModal(true);
  }
  const deleteOpenModal = (event, value) => {
    let uniqueId = value.id;
    let delURL = pageLayoutData[1].subComponentsItems.deleteApiEndPoint + '?id=' + uniqueId + '&customer_id=' + cookies.get('customer_id') + '&user_id=' + cookies.get('user_id') + '&language=' + language;
    switch (value.hasOwnProperty('is_mapped')) {
      case true:
        if (value?.is_mapped === 1) {
          swal({
            title: value.alert,
            text: "Do you want to un-map and delete?",
            icon: "info",
            buttons: [`${t('alerts.cancel')}`,
            `${t('alerts.ok')}`],
            dangerMode: true,
          })
            .then(async (willDelete) => {
              if (willDelete) {
                let res = await delelteData(delURL);
                if (res?.status == 400) {
                  swal(`${t(res.message)}`, {
                    icon: "warning",
                    buttons: t('alerts.ok'),
                  })
                } else {
                  swal(`${t('alerts.data_deleted')}`, {
                    icon: "success",
                    timer: 2000,
                    button: false
                  });
                  setTimeout(() => {
                    getLatestTableData();
                  }, 1000);
                }
              } else {
                swal(`${t('alerts.data_safe')}`, {
                  timer: 2000,
                  button: false
                });
              }
            })
        } else {
          (async function del1() {
            swal({
              title: `${t("alerts.sure")}`,
              text: `${t("alerts.deleted_not_recovered")}`,
              icon: "warning",
              buttons: [`${t('alerts.cancel')}`,
              `${t('alerts.ok')}`],
              dangerMode: true,
            })
              .then(async (willDelete) => {
                if (willDelete) {
                  let res = await delelteData(delURL);
                  if (res?.status == 400) {
                    swal(`${t(res.message)}`, {
                      icon: "warning",
                      buttons: t('alerts.ok'),
                    })
                  } else {
                    swal(`${t('alerts.data_deleted')}`, {
                      icon: "success",
                      timer: 2000,
                      button: false
                    });
                    setTimeout(() => {
                      getLatestTableData();
                    }, 1000);
                  }
                } else {
                  swal(`${t('alerts.data_safe')}`, {
                    timer: 2000,
                    button: false
                  });
                }
              })
          })()
        }
        break;
      default:
        (async function del1() {
          swal({
            title: `${t("alerts.sure")}`,
            text: `${t("alerts.deleted_not_recovered")}`,
            icon: "warning",
            buttons: [`${t('alerts.cancel')}`,
            `${t('alerts.ok')}`],
            dangerMode: true,
          })
            .then(async (willDelete) => {
              if (willDelete) {
                let res = await delelteData(delURL);
                if (res?.status == 400) {
                  swal(`${t(res.message)}`, {
                    icon: "warning",
                    buttons: t('alerts.ok'),
                  })
                } else {
                  swal(`${t('alerts.data_deleted')}`, {
                    icon: "success",
                    timer: 2000,
                    button: false
                  });
                  setTimeout(() => {
                    getLatestTableData();
                  }, 1000);
                }
              } else {
                swal(`${t('alerts.data_safe')}`, {
                  timer: 2000,
                  button: false
                });
              }
            })
        })();
    }
  }

  const openComponent = async() => {
    setIsLoader(true);  
    setuniqueId();
    setmodalType(`${t('add')}`);
    setModalformValues(pageLayoutData[0].addButtonItems)
    setRenderComponent(true);
    setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id')+'&language='+language);  
    const productViewEndpoint = pageLayoutData[1].subComponentsItems.hasOwnProperty('dropdownApiEndPoint') ? pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&language='+language  : 'not found';
    const productsViewJson = await getWizardDataService(productViewEndpoint)
    setIsLoader(false);
    setWizardData({
      productsView: productsViewJson,
    }) 
    setShowParentContent(!showParentContent);
  }  
  const editComponent = async(event, value) => {
    (pageLayoutData[0].editButtonItems !== undefined ? 
      setModalformValues(pageLayoutData[0].editButtonItems) : 
      setModalformValues(pageLayoutData[0].addButtonItems.formValues));
    let editURL = '';
      editURL = pageLayoutData[1].subComponentsItems.getApiEndPoint+ 
      '?id=' +value.id+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language;
      setDropDownApi(pageLayoutData[1].subComponentsItems.hasOwnProperty('dropdownApiEndPoint') ? pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&language='+language  : 'not found' );
    const productViewEndpoint = pageLayoutData[1].subComponentsItems.hasOwnProperty('dropdownApiEndPoint') ? pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&language='+language   : 'not found';
    setIsLoader(true);
    const productsViewJson = await getWizardDataService(productViewEndpoint);
    const productDetailsJson = await getWizardDataService(editURL);
    setIsLoader(false);

    setWizardData({
      productsView: productsViewJson,
      productsDetail: productDetailsJson,
    })
    setmodalType(`${t('edit')}`);
    setmodalgetURL(editURL)
    setuniqueId(value.id);
    (value.image) ? setImagePath(value.image) : setImagePath()
    setRenderComponent(true);
    setShowParentContent(false);
  }
  const handleDirection = () => {
    if (direction === "horizontal") {
      setDirection("vertical");
    }
    if (direction === "vertical") {
      setDirection("horizontal");
    }
  };
  
  
  useEffect(() => {
    (async () => {
      if (pageLayoutData != 'undefined') {
        if(pageLayoutData[1] && pageLayoutData[1].hasOwnProperty('subComponentsItems')) {
        setformValues(pageLayoutData[0].formValues);
        setShowParentContent(true);
        setshowFilter(false);
        setloadTableData(false);
        setsearchInputValue();
        setshowCSearch(false);
        setpage(1);
        setSelectedValue(1);
        let totalParams;
        let title1 = i18n.language == "chi" ? pageLayoutData[1].title1En : pageLayoutData[1].title1
        let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
        if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
          const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
          totalParams = {...totalParams, ...extraParameteres}
        }        
        if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
          const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
          totalParams = {...totalParams, ...firstTimeParameters}
        }
        totalParams = {...totalParams, ...dynamicParameters}
        if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
          let paramsConverted = new URLSearchParams(totalParams);
          getURL = (`${getURL}?${paramsConverted.toString()}`);
          let responseData = await FetchAPI(getURL);
          if(responseData.status == 200){
            setError(false);
            let responseDataJson = await responseData.json();
            setDefaultTextMessage(responseDataJson.data.message)
            if(pageLayoutData[1].title1==='Build/Software(s)'){
              for (let [key, value] of Object.entries(responseDataJson.data.data)) {        
                value.release_notes = <div>
                  <div onClick={(e) => buildDownload(e, value) } className="download-icon" >Document</div>              </div>;
              }}
            if(responseDataJson.data.hasOwnProperty('addPermission'))
            setAddButtonPermission(responseDataJson.data.addPermission)
            setFilteredCondition(responseDataJson.data.filterCondition)
            setExportPermission(responseDataJson.data.exportPermission)
            setAddPermission1(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName}Permission`])
            setImportPermission(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName') && pageLayoutData[0].importButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName.replace(/\s+/g, '') : pageLayoutData[0].importButtonName}Permission`])
            setImportPermission1(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName1') && pageLayoutData[0].importButtonName1.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName1.replace(/\s+/g, '') : pageLayoutData[0].importButtonName1}Permission`])
            setExportPermission1(responseDataJson.data[`export${pageLayoutData[0].hasOwnProperty('exportButtonName1') && pageLayoutData[0].exportButtonName1.indexOf(' ') >= 0 ? pageLayoutData[0].exportButtonName1.replace(/\s+/g, '') : pageLayoutData[0].exportButtonName1}Permission`])
            setIOTLoyaltyQtyPermission(responseDataJson.data.AvailableLoyaltyCodesPermission)
            setIotQtyPermission(responseDataJson.data.AvailableIOTsPermission)
            setFilterPermission(responseDataJson.data.filterPermission)
            setIOTFlag(responseDataJson.data.IOTFlag)
            setSyncPermission(responseDataJson.data.syncPermission)
              if(!isEmpty(responseDataJson.data.data)) {
               if(pageLayoutData[0].addButtonType == 'modal') {
                modalActions(responseDataJson.data)
                  }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                    buildActions(responseDataJson.data)
                  }else {
                    wizardActions(responseDataJson.data)
               }
              }
            setColumns(responseDataJson.data.columns);
            getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
            setproductsData(responseDataJson.data.data);
            setformValues(pageLayoutData[0].formValues);
            settotalrecords(responseDataJson.data.recordsTotal);
            setSelectOption(
              Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
            );
            setIotQty(responseDataJson.data.IOTQty)
            setIOTLoyaltyQty(responseDataJson.data.IOTLoyaltyQty)
            setRevertQty(responseDataJson.data.revertCount)
            setQty(responseDataJson.data.Qty)
            setloadTableData(true);
            setTpPermission(responseDataJson.data?.tpPermission)
          }
          else {
            setloadTableData(false);
            setError(true);
            setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
          }  
        }
        else {
          let responseData = await PostAPI(getURL, totalParams);
          if(responseData.status == 200){
            setError(false);
            let responseDataJson = responseData.data;
            if(!isEmpty(responseDataJson.data.data)) {
              setAddButtonPermission(responseDataJson.data.addPermission)
              setFilteredCondition(responseDataJson.data.filterCondition)
              setExportPermission(responseDataJson.data.exportPermission)
              setSyncPermission(responseDataJson.data.syncPermission)
              setAddPermission1(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName}Permission`])
              setImportPermission(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName') && pageLayoutData[0].importButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName.replace(/\s+/g, '') : pageLayoutData[0].importButtonName}Permission`])
              setImportPermission1(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName1') && pageLayoutData[0].importButtonName1.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName1.replace(/\s+/g, '') : pageLayoutData[0].importButtonName1}Permission`])
              setExportPermission1(responseDataJson.data[`export${pageLayoutData[0].hasOwnProperty('exportButtonName1') && pageLayoutData[0].exportButtonName1.indexOf(' ') >= 0 ? pageLayoutData[0].exportButtonName1.replace(/\s+/g, '') : pageLayoutData[0].exportButtonName1}Permission`])
              setIOTLoyaltyQtyPermission(responseDataJson.data.AvailableLoyaltyCodesPermission)
              setIotQtyPermission(responseDataJson.data.AvailableIOTsPermission)
              setIOTFlag(responseDataJson.data.IOTFlag)
              setFilterPermission(responseDataJson.data.filterPermission)
              if(pageLayoutData[0].addButtonType == 'modal') {
                modalActions(responseDataJson.data)
                  }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                    buildActions(responseDataJson.data)
                  }else {
                    wizardActions(responseDataJson.data)
               }
            }
            setColumns(responseDataJson.data.columns);
            getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
            setproductsData(responseDataJson.data.data);
            setformValues(pageLayoutData[0].formValues);
            settotalrecords(responseDataJson.data.recordsTotal);
            setSelectOption(
              Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
            );
            setloadTableData(true);
            setTpPermission(responseDataJson.data?.tpPermission)
          }
          else {
            setloadTableData(false);
            setError(true);
            setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
          }
        }
        (pageLayoutData[0].addButton == true && setModalformValues(pageLayoutData[0].addButtonItems.formValues));
      }
    }
    })()
  }, [pageLayoutData,direction])

  useEffect(() => {
    if (globalLoadIndicator == '2') {
      setPageLayoutData(pageLayoutDataContext);
    } else if (globalLoadIndicator == '1') {
      setPageLayoutData('undefined');
    }
  }, [globalLoadIndicator]);

  const onTop = () => {
    window.scrollTo(0, 0);
  }
  useEffect(() => {
    onTop()
  }, [page]);
  
  const openProductType = () => {
    const dropdownUrl = pageLayoutData[1].subComponentsItems.getExtraModalDropdowns+ '?customer_id='+ cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language
    setmodalType(`${t('add')}`);
    setModalTitle(pageLayoutData[0].addButtonName1);
    setModalWidth(pageLayoutData[0].addButtonItems1.className);
    setModalformValues(pageLayoutData[0].addButtonItems1.formValues)
    setSaveUrl(pageLayoutData[0].addButtonItems1.apiEndPointProductType)
    setDropDownApi(pageLayoutData[1].subComponentsItems.hasOwnProperty('getExtraModalDropdowns') ? dropdownUrl : 'not found'); 
    setshowModal(true);
  }
  const openLocation = () => {
    setModalTitle(pageLayoutData[0].addButtonName2);
    setModalWidth(pageLayoutData[0].addButtonItems2.className);
    setModalformValues(pageLayoutData[0].addButtonItems2.formValues)
    setSaveUrl(pageLayoutData[0].addButtonItems2.apiEndPointLocation)
    setmodalType(`${t('add')}`);
    setDropDownApi(pageLayoutData[1].subComponentsItems.getLocationDropdowns + '?customer_id='+ cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language); 
    setshowModal(true);
  }
  const openBusinessUnit = () => {
    setmodalType(`${t('add')}`);
    setModalTitle(pageLayoutData[0].addButtonName3);
    setModalWidth(pageLayoutData[0].addButtonItems3.className);
    setModalformValues(pageLayoutData[0].addButtonItems3.formValues)
    setSaveUrl(pageLayoutData[0].addButtonItems3.apiEndPointBussinessUnit)
    setDropDownApi(pageLayoutData[1].subComponentsItems.hasOwnProperty('getBusinessDropdowns') ? dropDownApi : 'not found')
    setshowModal(true);
  }
  const openUOM = () => {
    setmodalType(`${t('add')}`);
    setModalTitle(pageLayoutData[0].addButtonName4);
    setModalWidth(pageLayoutData[0].addButtonItems4.className);
    setModalformValues(pageLayoutData[0].addButtonItems4.formValues)
    setSaveUrl(pageLayoutData[0].addButtonItems4.apiEndPointUOM)
    setDropDownApi(pageLayoutData[1].subComponentsItems.hasOwnProperty('getBusinessDropdowns') ? dropDownApi : 'not found')
    setshowModal(true);
  }
  
  async function exportPdf(e, url) {
    e.preventDefault();
    window.location.href = url;
  }
  
  async function changeData(URL,data) {
    const getresponse = await PostAPI(URL,data);
    const responseData = getresponse;
  } 

  async function changeToggle(event, flag, id) {
    event.preventDefault();
    let check;
    if(flag.mandatory.props.children.props.value == 1)
      check = 0
    else
      check =1
    let newgetURL =  pageLayoutData[1].subComponentsItems.toggleApiEndPoint;
    let data = {flag: check, id: id}
    swal({
      title: "Are you sure?",
      text: "Beware what you are doing!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willapply) => {
      if (willapply) {
        changeData(newgetURL,data)
        swal("Poof! Your data has been modified!", {
          icon: "success",
          timer: 2000,
          button: false
        });
        setTimeout(() => {
          getLatestTableData();
        }, 1000);
      } 
      else {
        swal(`${t('alerts.something_went_wrong')}`, {
          icon: "error",
          timer: 2000,
          button: false
          });
      }
    });
  }

  async function exportFile(e) {
    e.preventDefault();
    setIsLoader(true);
    let val;
    if(pageLayoutData[0].formValues) 
      val = pageLayoutData[0].formValues;
    else
      val = 'undefined';
    const searchFormData = {};
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name'),
      language:language
    }
    const getURL = pageLayoutData[0].exportApiEndPoint ? 
    pageLayoutData[0].exportApiEndPoint : 'not found';
    let newgetURL,getresponse,dataObject,getresponseJson;
    let title1 = i18n.language == "chi" ? pageLayoutData[1].title1En : pageLayoutData[1].title1
    let title2 = i18n.language == "chi" ? pageLayoutData[1].title2En : pageLayoutData[1].title2
    dataObject = {
      ...requiredValues
    }
    if(val !== 'undefined') {
      for (let formElementIdentifier in values) {
        if(values[formElementIdentifier].elementType === 'multiselect') {
          if((values[formElementIdentifier].value)) {
            let arrayConvert = [];
            values[formElementIdentifier].value.map(function(fValue, indexId){
              arrayConvert[indexId] = fValue.value;
            });
            searchFormData[formElementIdentifier] = arrayConvert;
          }
          else
            searchFormData[formElementIdentifier] = null;
        }
        else{
        searchFormData[formElementIdentifier] = values[formElementIdentifier].value;
        }
    }
      dataObject = {...dataObject, ...searchFormData}
      if(pageLayoutData[0].hasOwnProperty('extraParametersDropdown')) {
        const extraParametersDropdown = pageLayoutData[0].extraParametersDropdown;
        dataObject = {...dataObject, ...extraParametersDropdown}
      }
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        const paramString = new URLSearchParams(dataObject);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        getresponse = await FetchAPI(newgetURL);
        getresponseJson = await getresponse.json()
        setIsLoader(false)
        window.location.href = getresponseJson?.data?.Location
      }
      else {
        getresponse = await PostAPI(getURL, dataObject);
        setIsLoader(false)
        window.location.href = getresponse.data?.data.Location
      }
    } else {
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        const paramString = new URLSearchParams(requiredValues);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        getresponse = await FetchAPI(newgetURL);
        getresponseJson = await getresponse.json()
      }
      else {
        getresponse = await PostAPI(getURL, requiredValues);
      }
    }
    if(getresponse.status == 200 && cookies.get('customer_id') !== "12"){
      swal({
        title:`${t("alerts.your_request_under_process")}`, 
        text:`${t("alerts.receive_email")}`, 
        icon:"success", 
        button:`${t("alerts.ok")}`
      })
    }else if(getresponse.status == 200 && cookies.get('customer_id') === "12" && (title1 === "IOT" || title2 === 'Report')){
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        window.location.href = getresponseJson.data.Location
      }else{
        window.location.href = getresponse.data.data.Location
      }
    }
    else{
      swal({
        title:`${t("alerts.something_went_wrong1")}`, 
        text:`${t("alerts.download_again")}`, 
        icon:"error", 
        button:`${t("alerts.ok")}`
      })
    }
  }
  async function exportFile1(e) {
    setIsLoader(true);
    e.preventDefault();
    let val;
    if(pageLayoutData[0].formValues) 
      val = pageLayoutData[0].formValues;
    else
      val = 'undefined';
    const searchFormData = {};
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name'),
      language:language
    }
    const getURL = pageLayoutData[0].exportApiEndPoint1 ? 
    pageLayoutData[0].exportApiEndPoint1 : 'not found';
    let newgetURL,getresponse,dataObject,getresponseJson;
    let title1 = i18n.language == "chi" ? pageLayoutData[1].title1En : pageLayoutData[1].title1
    let title2 = i18n.language == "chi" ? pageLayoutData[1].title2En : pageLayoutData[1].title2
    dataObject = {
      ...requiredValues
    }
    if(val !== 'undefined') {
      for (let formElementIdentifier in val) {
        searchFormData[formElementIdentifier] = val[formElementIdentifier].value;
      }
      dataObject = {...dataObject, ...searchFormData}
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        const paramString = new URLSearchParams(dataObject);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        getresponse = await FetchAPI(newgetURL);
        getresponseJson = await getresponse.json()
      }
      else {
        getresponse = await PostAPI(getURL, dataObject);
      }
    } else {
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        const paramString = new URLSearchParams(requiredValues);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        getresponse = await FetchAPI(newgetURL);
        getresponseJson = await getresponse.json()
      }
      else {
        getresponse = await PostAPI(getURL, requiredValues);
      }
    }
    if(getresponse.status == 200 && (title1 === "Role" || cookies.get('customer_id') !== "12")){
      setIsLoader(false);
      swal({
        title:`${t("alerts.your_request_under_process")}`, 
        text:`${t("alerts.receive_email")}`, 
        icon:"success", 
        button:`${t("alerts.ok")}`
      })
  }else if(getresponse.status == 200 && cookies.get('customer_id') === "12" && (title1 === "IOT" || title2 === 'Report')){
      setIsLoader(false);
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      window.location.href = getresponseJson.data.Location
    }else{
      window.location.href = getresponse.data.data.Location
    }
  }
    else{
      setIsLoader(false);
      swal({
        title:`${t("alerts.something_went_wrong1")}`, 
        text:`${t("alerts.download_again")}`, 
        icon:"error", 
        button:`${t("alerts.ok")}`
      })
    }
  }

  function serachFliterBoxData(data){

    let searchFormData = {}
  
    if(data){
      for (let formElementIdentifier in data) {
        if(data[formElementIdentifier].elementType === 'multiselect') {
            let multiselectData =   data[formElementIdentifier].value?.map((fValue, indexId)=> {
              return   fValue.value;
              });
              searchFormData[formElementIdentifier] = multiselectData;
          }
          else{
            searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
          }
        }
    }
    
  
    return searchFormData;
  }

  async function exportFile2(e) {
  if(navigator.onLine){
  e.preventDefault();
  setIsLoader(true);
  let getresponseJson;
  let requiredPayload = {
    ...dynamicParameters,
    email:localStorage.getItem('email')
  }
  let title2 = i18n.language == "chi" ? pageLayoutData[1].title2En : pageLayoutData[1].title2
  let getURL = pageLayoutData[0].exportApiEndPoint;
  const fmData = serachFliterBoxData(values)
  requiredPayload = {...requiredPayload,...fmData}
  if(pageLayoutData[0].exportEndpointType === "POST"){
    setIsLoader(true);
    const response = await PostAPI(getURL, requiredPayload)
    if(response.status === 200){
      setIsLoader(false);
      window.location.href = response?.data?.data?.Location
    }else{
      setIsLoader(false);
      swal({
        title:`${t("alerts.something_went_wrong1")}`, 
        text:`${t("alerts.download_again")}`, 
        icon:"error", 
        button:`${t("alerts.ok")}`
      })
    }
    return;
  }
  let paramsConverted = new URLSearchParams(requiredPayload);
  getURL = (`${getURL}?${paramsConverted.toString()}`);
  const getresponse = await FetchAPI(getURL);
  getresponseJson = await getresponse.json()
  setIsLoader(false);
  if(getresponse.status == 200 && cookies.get('customer_id') !== "12"){
    swal({
      title:`${t("alerts.your_request_under_process")}`, 
      text:`${t("alerts.receive_email")}`, 
      icon:"success", 
      button:`${t("alerts.ok")}`
    })
    window.location.href = getresponseJson?.data?.Location
  }
  else if(getresponse.status == 200 && cookies.get('customer_id') === "12"){
    setIsLoader(false);
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET' && title2 === 'Report') {
      window.location.href = getresponseJson.data.Location
    }else if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'POST' && title2 === 'Report'){
      window.location.href = getresponse.data.data.Location
    }
    else{
      setIsLoader(false);
      swal({
        title:`${t("alerts.your_request_under_process")}`, 
        text:`${t("alerts.receive_email")}`, 
        icon:"success", 
        button:`${t("alerts.ok")}`
      })
    }
  }
}
  else{
    swal({
      title:`${t("alerts.something_went_wrong1")}`, 
      text:`${t("alerts.download_again")}`, 
      icon:"error", 
      button:`${t("alerts.ok")}`
    })
  }
}

const handlePageChange = (e) => {
  setSelectedValue(e.target ? e.target.value : e);
  handleLatestTableData(e.target ? e.target.value : e);
};

const handleChangeReference = (e) => {
  setReferenceValue(e.target.value)
}

const handleSubmitReference = async(e) => {
  e.preventDefault();
  if(validate.allValid()){
    const payload = {
      status: completedRecord.status,
      loyalty_wallet_transaction_id: completedRecord.loyalty_wallet_transaction_id,
      reference_id: referenceValue,
      ...dynamicParameters
    }
  const endpoint = pageLayoutData[1].subComponentsItems.apiEndPoint2;
  setIsLoader(true);
  const response = await PostAPI(endpoint,payload)
  setIsLoader(false)
  getStatusAlert({status: response?.data?.data?.status,message: response?.data?.data?.message,reCallGrid: getLatestTableData})
  if(response.status === 200) {
    setshowTPModal(false)
    setReferenceValue("")
  }
  }else{
    showValidationMessage(true)
  }
} 
  const options = {
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    sizePerPage: sizePerPage,
    page: page,
    totalSize: totalrecords
  }

  const RemotePagination = ({ data, page, sizePerPage, onTableChange, totalSize, baseValue }) => (
    <div className={`${totalQuantities?.length > 0 ? "show-total-qty" : ""}`} >
      <BootstrapTable
        remote
        keyField="id"
        striped
        hover
        condensed
        bordered={false}
        {...baseValue}
        pagination={paginationFactory({
          ...options,
          page: Number(selectedValue),
        })}
        onTableChange={onTableChange}
        noDataIndication={pageLayoutData[1].title1 === 'Weighing' && totalrecords === undefined  ? defaultTextMessage  : t("no_data")}
        wrapperClasses="table-responsive overflow-class"
      />
      {
        totalQuantities?.length > 0 && (
          <div className="report-qty">
            {totalQuantities.map(record => (
              <div>{`TOTAL ${record.name}`}&nbsp; <span className="report-qty-color" > {`: ${record.count}`}</span></div>
            ))}
          </div>
        )
      } 
      {(selectOption > 0 && !(
  cookies.get("customer_id") == 12 &&
  hidePaginationDropdown.includes(pageLayoutData[1].title1)
) ) && (
        <div
          class="Dropdown"
          style={{ marginTop: "-45px", position: "absolute", fontSize: "13px" }}
        >
          <p style={{ float: "left", fontSize: "13px" }}>{t("Page No:")}</p>
          <select onChange={handlePageChange} value={selectedValue}>
            {Array.from(Array(selectOption), (e, i) => {
              return (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              );
            })}
          </select>
        </div>
      )}
      {isLoader===true&&<div className="beat-loader" ><BeatLoader  color={"#3C423C"} /></div>}
    </div>
  );

return (
  (pageLayoutData != 'undefined' && cookies.get('pagetype_id') == 2) ?
  (cookies.get('user_id') !== '154' && pageLayoutData[1].title1 == 'Un-Bind') ?
      <div className="dynamic-content">
        <Grid fluid>
          <div className="text-center" style={{ margin: "13em" }}>
            <img style={{ width: '50px', marginTop: '0px' }} src={logoValMain} alt="logo_image" />
            <h3>User dont have permission to Un-Bind</h3>
            <h5>Please contact admin.</h5>
          </div>
        </Grid>
      </div>
      :
      <div className="content" id="pdfcontent">
        <Grid fluid>
          <Row>
            <Col md={12} style={{ marginTop: '0px' }}>
              <Card style={{ fontSize: '12px' }}
                hCenter = {(pageLayoutData[1]) && (pageLayoutData[1].title3) ? `${pageLayoutData[1].title3} : ` : " "}
                iotQty = {iotQty}
                title={(pageLayoutData[1]) ? pageLayoutData[1].title1 : ''}
                title2={(pageLayoutData[1]) ? pageLayoutData[1].title2 : ''}
                IOTFlag = {IOTFlag}
                content={
                <div>
                {showParentContent ?
                  <ToolkitProvider
                    keyField="id"
                    data={productsData}
                    columns={columnsModified}
                    search
                    exportCSV
                  >
                    {
                      props => (
                        <div>
                            <MySearch {...props.searchProps} />
                            <br></br>
                            <br></br>
                            <br></br>
                          {(pageLayoutData[1]) && (i18n.language === "chi" ? (pageLayoutData[1].title1En == 'Assign') : pageLayoutData[1].title1 == 'Assign') ?
                            <MDBCol md="2" className="mb-1">
                              {!IOTFlag && pageLayoutData[1].title3 == "Available Serial Number" &&
                            <div className="form-control">
                                <label htmlFor="" style={{fontWeight: '400'}}>{t('total_assigned')}</label>
                                <input type="text" name="assigned" className="form-control" readOnly="readOnly" value={qty}/>
                                </div>
                              }
                            </MDBCol>
                            :(pageLayoutData[1]) && (i18n.language === "chi" ? pageLayoutData[1].title1En == 'Assign Buffer' : pageLayoutData[1].title1 == 'Assign Buffer') ?
                            <MDBCol md="2" className="mb-1">
                            <div className="form-control">
                                <label htmlFor="" adjustsFontSizeToFit={true} numberOfLines={1}  style={{fontWeight: '400',textAlignVertical: "center",textAlign: "center",marginTop:"-7px"}}>{t("total_assigned_buffer")}</label>
                                <input type="text" name="assigned" className="form-control" readOnly="readOnly" style={{marginTop:"-7px"}} value={qty}/>
                                </div>
                                <br></br>
                            </MDBCol>
                            :(pageLayoutData[1]) && (i18n.language === "chi" ? pageLayoutData[1].title1En == 'Revert Assigned' : pageLayoutData[1].title1 == 'Revert Assigned') ?
                            <MDBCol md="2" className="mb-1">
                            <div className="form-control">
                                <label htmlFor="" adjustsFontSizeToFit={true} numberOfLines={1}  style={{fontWeight: '400',textAlignVertical: "center",textAlign: "center",marginTop:"-7px"}}>{t("total_revert_assigned")}</label>
                                <input type="text" name="assigned" className="form-control" readOnly="readOnly" style={{marginTop:"-7px"}} value={revertqty}/>
                                </div>
                                <br></br>
                            </MDBCol>
                            : null }
                            {/* <MDBCol md="6" className="mb-6">
                              {<SearchBar {...props.searchProps} />}
                              <ClearSearchButton {...props.searchProps} />
                            </MDBCol> */}
                            <br />
                            {IOTFlag && 
                              <MDBRow>
                                <MDBCol md="4" className="mb-4" style={{textAlign: "left",padding: '0% 4%'}} >{iotQtyPermission && <h5>{`${pageLayoutData[1].title3}: `} <span style={{color: "red"}} >{iotQty}</span> </h5> }</MDBCol>
                                <MDBCol md="4" className="mb-4"></MDBCol>
                                <MDBCol md="4" className="mb-4" style={{textAlign: "right",padding: '0% 4%'}} >{IOTLoyaltyQtyPermission && <h5>{`${pageLayoutData[1].title4}: `} <span style={{color: "red"}}  >{IOTLoyaltyQty}</span> </h5>}</MDBCol>
                              </MDBRow>
                            }
                          <MDBRow>
                            <MDBCol md="12" className="mb-12">
                            {loadTableData ?
                              <div className="button-container" style={{marginTop:'10px'}}>
                                {((pageLayoutData[0].exportButton === true && pageLayoutData[0].filterStatus === false) || (exportPermission===true && pageLayoutData[0].filterStatus===false)) ? <ButtonField color="info"submit = {(e) => exportFile2(e)} BName = {t("export_csv")}/> :''}
                                {((syncPermission === true && pageLayoutData[1].title1 == "Inventory Sync to")) ? <button style={{ borderRadius: '15px',fontSize: '9px' }} disabled={disabledButton} onClick={(event) => syncInventory(event)} class="btn btn-outline-primary btn-rounded waves-effect">{'Sync Data'}</button> : ''}
                                {((pageLayoutData[0].exportButton === true && pageLayoutData[0].filterStatus === true) || (exportPermission === true && pageLayoutData[0].filterStatus === true)) ? <ButtonField color="info"submit = {(e) => exportFile(e)} BName={t("export_csv")}/> :''}
                                { !IOTFlag && (pageLayoutData[0].filterStatus === true ) ? <ButtonField color="info" key="Filter" submit={() => openFilter()} BName={t("filter")} /> : ''}
                                {(pageLayoutData[0].exportButton1 === true || exportPermission1 === true) ? <ButtonField color="info" submit={(e) => exportFile1(e)} BName={`${t("export")} `+ pageLayoutData[0].exportButtonName1} /> : ''}
                                { !IOTFlag && (pageLayoutData[0].addButton === true && addButtonPermission == true && pageLayoutData[0].addButtonType == 'modal' && pageLayoutData[1].title1 === 'Un-Bind' ? 
                                <ButtonField color="info" submit={() => open()} BName={t(pageLayoutData[0].addButtonName) } /> : 
                                ((pageLayoutData[0].addButton === true && addButtonPermission == true && pageLayoutData[0].addButtonType == 'modal') || (addPermission1 === true && pageLayoutData[0].addButtonType == 'modal')) ? <ButtonField color="info" submit={() => open()} BName={`${t("add")} `+ pageLayoutData[0].addButtonName } /> : '')}
                                {(pageLayoutData[0].addButton === true && pageLayoutData[0].addButtonType == 'buildmodal' && (addButtonPermission == true) ) ? <ButtonField color="info" submit={() => buildModal()} BName={`${t("Add Build/Software")} `} /> : ''}
                                {((pageLayoutData[0].addButton === true && pageLayoutData[0].addButtonType == 'wizard') || (addPermission1 === true && pageLayoutData[0].addButtonType == 'wizard')) ?  <ButtonField color="info" submit={() => openComponent()} BName={`${t("add")} ` + pageLayoutData[0].addButtonName} /> : ''}
                                {(pageLayoutData[0].addButton1 === true) ? <ButtonField color="info" submit={() => openProductType()} BName={`${t("add")} `+ pageLayoutData[0].addButtonName1} /> : ''}
                                {(pageLayoutData[0].addButton2 === true) ? <ButtonField color="info" submit={() => openLocation()} BName={`${t("add")} `+ pageLayoutData[0].addButtonName2} /> : ''}
                                {(pageLayoutData[0].addButton3 === true) ? <ButtonField color="info" submit={() => openBusinessUnit()} BName={`${t("add")} `+ pageLayoutData[0].addButtonName3} /> : ''}
                                {(pageLayoutData[0].addButton4 === true) ? <ButtonField color="info" submit={() => openUOM()} BName={`${t("add")} `+ pageLayoutData[0].addButtonName4} /> : ''}
                                {((pageLayoutData[0].importButton === true || importPermission === true)) ? <ButtonField color="info" submit={() => openImport()} BName={`${t("import")} `+ pageLayoutData[0].importButtonName} /> : ''}
                                {((pageLayoutData[0].importButton1 === true || importPermission1 === true)) ? <ButtonField color="info" submit={() => openImport1()} BName={`${t("import")} `+ pageLayoutData[0].importButtonName1} /> : ''}
                                {showModal ?
                                  <ModalBox
                                    key={ pageLayoutData[0].featureId }
                                    showModal={showModal}
                                    titlePreFix = { modalType }
                                    modalWidth = { modalWidth}
                                    buildValue={staticModalformValues}
                                    title={ modalTitle }
                                    formValue={ModalformValues}
                                    addURL={ saveUrl }
                                    getURL={ modalgetURL }
                                    uniqueid={ uniqueId }
                                    extraId = {extraId}
                                    commonTitle = {commonTitle}
                                    drpdwnApi = {pageLayoutData[1].subComponentsItems.hasOwnProperty('dropdownApiEndPoint') ? dropDownApi : 'not found' }
                                    recallMehod= { getLatestTableData }
                                    hide={close}
                                    headers = {headers}
                                    table = {table}
                                    unBindUrl={unBindUrl}
                                    dyn_template = {pageLayoutData[0].importDynamicTemplate}
                                    editId={editId}
                                    loyaltyRedeem = {loyaltyRedeem}
                                  />
                                : ''}
                              </div>
                            : ''
                            }
                            </MDBCol>
                            </MDBRow>
                            {showFilter ?
                              <FilterBox
                                key="FilterBox"
                                formValue={formValues}
                                disabled={disabledButton}
                                setformValues = { setformValues }
                                setSelectChildValue={setSelectChildValue}
                                change={inputChangedHandler}
                                searchClick={ searchTableData }
                                isFilterLoader={isFilterLoader}
                                filteredExport = {filteredExport}
                                filteredExport1 = {filteredExport1}
                                filteredExport2 = {filteredExport2}
                                filterCondition ={filteredCondition}
                                selectChildValue={selectChildValue}
                                clearClick={clearTableData}
                                title={pageLayoutData[1].title1}
                                commonTitle = {i18n.language === 'chi' ? pageLayoutData[1].title1En : pageLayoutData[1].title1}
                                dropDownApi = {dropDownApi}
                                validate={validator} 
                                exportFilterButton={pageLayoutData[0].exportFilterButton === true ? true : false}
                                exportFilterButton1={pageLayoutData[0].exportFilterButton1 === true ? true : false}
                                exportFilterButtonName1={pageLayoutData[0].hasOwnProperty('exportFilterButtonName1') === true ? pageLayoutData[0].exportFilterButtonName1 : ''}
                                exportFilterButtonName={pageLayoutData[0].hasOwnProperty('exportFilterButtonName') === true ? pageLayoutData[0].exportFilterButtonName: ''}
                                exportApiEndPoint={pageLayoutData[0].exportApiEndPoint ? 
                                  pageLayoutData[0].exportApiEndPoint : 'not found'}
                              />
                            : ''}
                            {loadTableData ?
                              <RemotePagination
                                page={page}
                                sizePerPage={sizePerPage}
                                totalSize={totalrecords}
                                baseValue={props.baseProps}
                                onTableChange={handleTableChange}
                              />
                              : 
                              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                              { error ?   
                              <h4> { errorMsg } </h4> 
                              :
                              <Grid fluid>
                              <div className="text-center"><LoadingSpinner /></div>
                              </Grid> 
                              }
                              </div>
                            }
                          </div>
                        )}
                  </ToolkitProvider>
                  :  
                  <div>
                    {renderComponent && 
                    <Wizard 
                      setShowParentContent={setShowParentContent} 
                      pageLayoutData={ModalformValues}
                      pageLayoutData1={pageLayoutData[0]} 
                      pageLayoutData2 = {pageLayoutData[1].subComponentsItems}
                      addURL={pageLayoutData[1].subComponentsItems.saveApiEndPoint}
                      wizardTitle =  {pageLayoutData[1].title1}
                      getURL={modalgetURL} 
                      locationDropDownAPI={pageLayoutData[1].subComponentsItems.hasOwnProperty('getLocationDropdowns') ? pageLayoutData[1].subComponentsItems.getLocationDropdowns+'?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id') : 'not found' }
                      dropDwnApi = {dropDownApi}
                      featureName={i18n.language === "chi" ? pageLayoutData[0].addButtonNameEn :  pageLayoutData[0].addButtonName} 
                      commonTitle = {commonTitle}
                      titlePreFix = { modalType } 
                      productId={productId}
                      uniqueId={uniqueId}
                      imagePath={imagePath}
                      updatePageDataURL={pageLayoutData[1].subComponentsItems.addRoleView} 
                      recallMethod= { getLatestTableData }
                      showParentContent = {showParentContent}
                      setformValues = {setformValues}
                      setModalformValues = {setModalformValues}
                    />}
                    
                  </div>
                }
                {showTPModal ?
                  <Modal show={showTPModal} onHide={closeTPModal} dialogClassName={modalWidthTitles.includes(pageLayoutData[1].title1) ? "modal-60w" : "modal-90w"} backdrop="static" keyboard={false}>
                    <Modal.Header closeButton className="modal-close-button" >
                      <Modal.Title>{tpPermission && "TP:"}
                        <a href='#!' className='font-weight-bold' style={{color:'#D54C2F'}}>
                          <strong> {modalTitle}</strong>
                        </a>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                      <MDBRow>
                        <MDBCol md={tpPermission ? "4" : "12"} className="mb-4">
                        {loadTableDataChild ?
                          <ToolkitProvider
                            keyField="id"
                            data={productsDataChild}
                            columns={columnsChild}
                          >
                            {props => (
                              <div>
                                <BootstrapTable
                                  { ...props.baseProps }
                                  striped
                                  hover
                                  condensed
                                  bordered={ false }
                                  pagination={productsDataChild.length > 10 ? paginationFactory({hideSizePerPage: true}) : ''}
                                  height={ productsDataChild.length > 10 ? 510 : false}
                                  noDataIndication={t("no_data")}
                                  wrapperClasses="table-responsive overflow-class"
                                />
                                {pageLayoutData[1]?.customForm && (<form>
                                        <label className="Label">Reference No*</label>
                                        <div className="reference-id" >
                                          <input type="text" name="reference_id" className="form-control" placeholder="Reference No" onChange={handleChangeReference} value={referenceValue} maxLength={24} autoComplete="off" />
                                          <ButtonField color="info" submit={handleSubmitReference} BName={"Submit"} />
                                        </div>
                                        <span>{validate.message("Reference No", referenceValue, "required|alpha_num|max:24")}</span>
                                        <hr />
                                      </form>)}
                                {(syncSapMessage.status === "Sync failed" && syncSapMessage.message) && <div className="sync-sap-message" ><p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {syncSapMessage.message}</p></div>}
                              </div>
                            )}
                          </ToolkitProvider>
                        :  
                        <div>
                        </div>
                        }
                        </MDBCol>
                        <MDBCol md="8" className="mb-8"  > 
                          {showTimeline ?
                            <div ref={myRef}>
                              <Modal.Title>
                                <span style={{color:'black',marginLeft: '30%',
                                                  paddingTop: '15%'}}>IOT:</span>
                                <a href='#!' className='font-weight-bold' style={{color:'#D54C2F'}}>
                                <strong> {timelineTitle}</strong>
                                </a>
                              </Modal.Title>
                              {(Object.keys(timelineData).length !== 0) ?
                              <Timeline lineColor={'#ddd'} style={{marginLeft:'10px',height:'auto'}}>
                                {timelineData.map((prop, key) => {
                                  return  <TimelineItem
                                            key={key}
                                            dateText={prop.transaction}
                                            style={{ color: '#e86971' }} 
                                          >
                                          <h6>{prop.SourceLoc}</h6>
                                          </TimelineItem>
                                  })
                                }
                              </Timeline>
                               : 
                               <h4 className="col-md-6 col-md-offset-4">No Track Details!</h4>
                              }
                              {/* </div> */}
                            </div>
                            : ''
                          }
                        </MDBCol>
                      </MDBRow>
                    </Modal.Body>
                    <Modal.Footer>
                      <MDBRow className='d-flex align-items-center mb-4'>
                        <div className='text-center mb-3 row'>
                          <ButtonField submit={closeTPModal} color="info" BName="Close" />
                        </div>
                      </MDBRow>
                    </Modal.Footer>        
                  </Modal>
                : 
                ''
                }
                  </div>
                }
          />
            </Col>
          </Row>
        </Grid>


      </div>
      : <div className="content">
      <Grid fluid>
      <div className="text-center"><LoadingSpinner /></div>
      </Grid>
    </div>
  );
}

export default Role;

